import { Field } from "./Field.tsx";
import { useSignal } from "@preact/signals";
import { TextareaField } from "./TextareaField.tsx";
import { ComponentChildren } from "preact";

export function PartyRegistrationForm(props: { children: ComponentChildren }) {
  const loading = useSignal(false);
  const errorMessage = useSignal("");
  const textMessage = useSignal("");

  async function onSubmit(e: Event) {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    loading.value = true;
    errorMessage.value = "";
    textMessage.value = "";

    try {
      const res = await fetch("/api/party-register", { method: "POST", body: formData });

      if (!res.ok) {
        /* try to parse backend error, else show generic */
        const bodyText = await res.text();
        let friendly = "Something went wrong.";

        try {
          const obj = JSON.parse(bodyText);
          if (obj?.message?._errors?.[0]) friendly = obj.message._errors[0];
          else if (obj?._errors?.[0]) friendly = obj._errors[0];
          else if (bodyText) friendly = bodyText;
        } catch {
          if (bodyText) friendly = bodyText;
        }

        errorMessage.value = friendly;
        return;
      }

      /* success */
      form.reset();
      textMessage.value = "You're registered! See you Tuesday, November 3.";
    } catch (err) {
      console.error(err);
      errorMessage.value = "Network error. Please try again later.";
    } finally {
      loading.value = false;
    }
  }

  return (
    <div class="contact-form">
      <div class="chasing-border">
        <div class="frame">
          {props.children}

          <form method="POST" onSubmit={onSubmit}>
            <div>
              <Field type="text" name="name" label="Full Name" required autoComplete="name" />
              <Field type="text" name="jobTitle" label="Job Title" required autoComplete="organization-title" />
            </div>
            <div>
              <Field type="text" name="company" label="Company" required autoComplete="organization" />
              <Field type="email" name="email" label="Email" required autoComplete="email" />
            </div>
            <div class="bottom-part" style={{ maxWidth: "100%" }}>
              <div style={{ height: 0, width: 0, position: "absolute", overflow: "hidden" }} aria-hidden="true">
                {/* Spam honeypot: named "website" so browsers never autofill it */}
                <TextareaField
                  name="website"
                  label="Website"
                  rows={10}
                  cols={47}
                  tabIndex={-1}
                  autoComplete="off"
                />
              </div>
              <div class="submit">
                <button class="cta-button" disabled={loading.value}>
                  {loading.value ? "Registering…" : "Register"}
                </button>
                {loading.value && <span class="loader"></span>}
                {errorMessage.value && (
                  <span class="error-message">{errorMessage.value}</span>
                )}
                {textMessage.value && (
                  <span class="text-message">{textMessage.value}</span>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
